var $0ed2db6e68f48ea3$exports = {};
$0ed2db6e68f48ea3$exports = {
    "collapse": `D\xf6lj`,
    "expand": `Expandera`
};


export {$0ed2db6e68f48ea3$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
